import React from 'react';

import { ExchangeWrapper } from './exchangeStyles';
import { BuyBridgeNomQuote } from './BuyBridgeNomQuote';
import { useExchange } from 'context/exchange/ExchangeContext';
import LoadingSpinner from 'components/UI/LoadingSpinner';
import { SellBridgeNomQuote } from './SellBridgeNomQuote';
import { ExchangeMobile } from './ExchangeMobile';

export default function Exchange() {
  const { loadingStatus } = useExchange();
  if (loadingStatus.pending) return <LoadingSpinner />;
  return (
    <ExchangeWrapper>
      <ExchangeMobile />
      <div id="tour-buy">
        <BuyBridgeNomQuote />
      </div>
      <div id="tour-sell">
        <SellBridgeNomQuote />
      </div>
    </ExchangeWrapper>
  );
}
